<template>
  <div class="innerPage">
    <div class="innerPageHead">
      <div class="innerPageTitle">
        <h2>{{ $t("TopNav03") }}</h2> 
      </div>
      <div class="innerPagePagination">
        <b-container>
          <b-breadcrumb :items="items"></b-breadcrumb>
        </b-container>
      </div>
    </div>

    <div class="interPageMainContain">
      <b-container>
          <h3 class="font-weight-bold text-center">{{ $t("Guest_title01") }}</h3>
          <b-row cols="1" cols-lg="2">
            <b-col>
              <div class="guest-wrap">
                <b-row>
                  <b-col cols="4">                    
                    <div class="guest-pic">
                      <b-img
                        :src="require('@/assets/imgs/guest/Li-Yuan.jpg')"
                        fluid
                        alt="Li-Yuan"
                      ></b-img>
                    </div>
                  </b-col>
                  <b-col cols="8">
                     <div class="guest-title">{{ $t("1-1_Guest_Name") }}</div>
                     <div class="guest-info">
                        <p>{{ $t("1-1_Guest_Info") }}</p>                         
                    </div>
                    <div class="guest-content">
                      <h5>{{ $t("Guest_Education") }}</h5>
                      <ul>
                        <li>{{ $t("1-1_Guest_Education-1") }}</li>
                        <li>{{ $t("1-1_Guest_Education-2") }}</li>
                      </ul>
                      <h5>{{ $t("Guest_Experience") }}</h5>
                      <ul>
                        <li>{{ $t("1-1_Guest_Experience-1") }}</li>
                        <li>{{ $t("1-1_Guest_Experience-2") }}</li>
                        <li>{{ $t("1-1_Guest_Experience-3") }}</li>
                        <li>{{ $t("1-1_Guest_Experience-4") }}</li>
                        <li>{{ $t("1-1_Guest_Experience-5") }}</li>
                        <li>{{ $t("1-1_Guest_Experience-6") }}</li>
                      </ul>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>

            <b-col>
              <div class="guest-wrap">
                <b-row>
                  <b-col cols="4">                    
                    <div class="guest-pic">
                      <b-img
                        :src="require('@/assets/imgs/guest/CHEN_CHI-MING.jpg')"
                        fluid
                        alt="CHEN_CHI-MING"
                      ></b-img>
                    </div>
                  </b-col>
                  <b-col cols="8">
                     <div class="guest-title">{{ $t("1-2_Guest_Name") }}</div>
                     <div class="guest-info">
                        <p>{{ $t("1-2_Guest_Info") }}</p>                         
                    </div>
                    <div class="guest-content">
                      <h5>{{ $t("Guest_Education") }}</h5>
                      <ul>
                        <li>{{ $t("1-2_Guest_Education-1") }}</li>
                      </ul>
                      <h5>{{ $t("Guest_Experience") }}</h5>
                      <ul>
                        <li>{{ $t("1-2_Guest_Experience-1") }}</li>
                        <li>{{ $t("1-2_Guest_Experience-2") }}</li>
                        <li>{{ $t("1-2_Guest_Experience-3") }}</li>
                        <li>{{ $t("1-2_Guest_Experience-4") }}</li>
                        <li>{{ $t("1-2_Guest_Experience-5") }}</li>
                      </ul>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>

            <b-col>
              <div class="guest-wrap">
                <b-row>
                  <b-col cols="4">                    
                    <div class="guest-pic">
                      <b-img
                        :src="require('@/assets/imgs/guest/Lin_Hwa-Ching.png')"
                        fluid
                        alt="Lin Hwa-Ching"
                      ></b-img>
                    </div>
                  </b-col>
                  <b-col cols="8">
                     <div class="guest-title">{{ $t("1-3_Guest_Name") }}</div>
                     <div class="guest-info">
                        <p>{{ $t("1-3_Guest_Info") }}</p>                         
                    </div>
                    <div class="guest-content">
                      <h5>{{ $t("Guest_Education") }}</h5>
                      <ul>
                        <li>{{ $t("1-3_Guest_Education-1") }}</li>
                      </ul>
                      <h5>{{ $t("Guest_Experience") }}</h5>
                      <ul>
                        <li>{{ $t("1-3_Guest_Experience-1") }}</li>
                        <li>{{ $t("1-3_Guest_Experience-2") }}</li>
                        <li>{{ $t("1-3_Guest_Experience-3") }}</li>
                        <li>{{ $t("1-3_Guest_Experience-4") }}</li>
                        <li>{{ $t("1-3_Guest_Experience-5") }}</li>
                        <li>{{ $t("1-3_Guest_Experience-6") }}</li>
                      </ul>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>

            <b-col>
              <div class="guest-wrap">
                <b-row>
                  <b-col cols="4">                    
                    <div class="guest-pic">
                      <b-img
                        :src="require('@/assets/imgs/guest/Chen_Yu-Hsiu.jpg')"
                        fluid
                        alt="Chen Yu-Hsiu"
                      ></b-img>
                    </div>
                  </b-col>
                  <b-col cols="8">
                     <div class="guest-title">{{ $t("1-4_Guest_Name") }}</div>
                     <div class="guest-info">
                        <p>{{ $t("1-4_Guest_Info") }}</p>                         
                    </div>
                    <div class="guest-content">
                      <h5>{{ $t("Guest_Education") }}</h5>
                      <ul>
                        <li>{{ $t("1-4_Guest_Education-1") }}</li>
                        <li>{{ $t("1-4_Guest_Education-2") }}</li>
                      </ul>
                      <h5>{{ $t("Guest_Experience") }}</h5>
                      <ul>
                        <li>{{ $t("1-4_Guest_Experience-1") }}</li>
                        <li>{{ $t("1-4_Guest_Experience-2") }}</li>
                        <li>{{ $t("1-4_Guest_Experience-3") }}</li>
                        <li>{{ $t("1-4_Guest_Experience-4") }}</li>
                        <li>{{ $t("1-4_Guest_Experience-5") }}</li>
                      </ul>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>

          </b-row>
          <h3 class="font-weight-bold text-center">{{ $t("Guest_title02") }}</h3>
          <b-row cols="1">
            <b-col>
              <div class="guest-wrap">
                <b-row>
                  <b-col cols="4" lg="2">                    
                    <div class="guest-pic">
                      <b-img
                        :src="require('@/assets/imgs/guest/Teresa.png')"
                        fluid
                        alt="Teresa Patrício"
                      ></b-img>
                    </div>
                  </b-col>
                  <b-col cols="8" lg="10">
                     <div class="guest-title">Teresa Patrício</div>
                     <div class="guest-info">
                      <ul>
                        <li>{{ $t("2-1_Guest_Info-1") }}</li>
                        <li>{{ $t("2-1_Guest_Info-2") }}</li>
                      </ul>                    
                    </div>
                    <div class="guest-content">
                      <h5>{{ $t("Guest_Intro") }}</h5>
                      <p>{{ $t("2-1_Guest_Intro-1") }}</p>
                      <p>{{ $t("2-1_Guest_Intro-2") }}</p>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col>
              <div class="guest-wrap">
                <b-row>
                  <b-col cols="4" lg="2">                    
                    <div class="guest-pic">
                      <b-img
                        :src="require('@/assets/imgs/guest/SteveBrown.jpg')"
                        fluid
                        alt="Steve Brown"
                      ></b-img>
                    </div>
                  </b-col>
                  <b-col cols="8" lg="10">
                     <div class="guest-title">Steve Brown</div>
                     <div class="guest-info">
                      <ul>
                        <li>{{ $t("2-2_Guest_Info-1") }}</li>
                        <li>{{ $t("2-2_Guest_Info-2") }}</li>
                        <li>{{ $t("2-2_Guest_Info-3") }}</li>
                      </ul>                    
                    </div>
                    <div class="guest-content">
                      <h5>{{ $t("Guest_Intro") }}</h5>
                      <p>{{ $t("2-2_Guest_Intro-1") }}</p>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col>
              <div class="guest-wrap">
                <b-row>
                  <b-col cols="4" lg="2">                    
                    <div class="guest-pic">
                      <b-img
                        :src="require('@/assets/imgs/guest/MichaelReilly.jpg')"
                        fluid
                        alt="Michael Reilly"
                      ></b-img>
                    </div>
                  </b-col>
                  <b-col cols="8" lg="10">
                     <div class="guest-title">Michael Reilly</div>
                     <div class="guest-info">
                      <ul>
                        <li>{{ $t("2-3_Guest_Info-1") }}</li>
                        <li>{{ $t("2-3_Guest_Info-2") }}</li>
                      </ul>                    
                    </div>
                    <div class="guest-content">
                      <h5>{{ $t("Guest_Intro") }}</h5>
                      <p>{{ $t("2-3_Guest_Intro-1") }}</p>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col>
              <div class="guest-wrap">
                <b-row>
                  <b-col cols="4" lg="2">                    
                    <div class="guest-pic">
                      <b-img
                        :src="require('@/assets/imgs/guest/PatrickMiescher.jpg')"
                        fluid
                        alt="Patrick Miescher"
                      ></b-img>
                    </div>
                  </b-col>
                  <b-col cols="8" lg="10">
                     <div class="guest-title">Patrick Miescher</div>
                     <div class="guest-info">
                      <ul>
                        <li>{{ $t("2-4_Guest_Info-1") }}</li>
                      </ul>                    
                    </div>
                    <div class="guest-content">
                      <h5>{{ $t("Guest_Intro") }}</h5>
                      <p>{{ $t("2-4_Guest_Intro-1") }}</p>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>

            <b-col>
              <div class="guest-wrap">
                <b-row>
                  <b-col cols="4" lg="2">                    
                    <div class="guest-pic">
                      <b-img
                        :src="require('@/assets/imgs/guest/Akira_Torizuka.png')"
                        fluid
                        alt="Akira Torizuka"
                      ></b-img>
                    </div>
                  </b-col>
                  <b-col cols="8" lg="10">
                     <div class="guest-title">{{ $t("2-5_Guest_name") }}</div>
                     <div class="guest-info">
                      <ul>
                        <li>{{ $t("2-5_Guest_Info-1") }}</li>
                      </ul>                    
                    </div>
                    <div class="guest-content">
                      <h5>{{ $t("Guest_Intro") }}</h5>
                      <p>{{ $t("2-5_Guest_Intro-1") }}</p>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>

          <h3 class="font-weight-bold text-center">{{ $t("Guest_title03") }}</h3>
          <b-row cols="1">
            <b-col>
              <div class="guest-wrap">
                <b-row>
                  <b-col cols="4" lg="2">                    
                    <div class="guest-pic">
                      <b-img
                        :src="require('@/assets/imgs/guest/Huang_Ho-Ting.png')"
                        fluid
                        alt="Huang, Ho-Ting"
                      ></b-img>
                    </div>
                  </b-col>
                  <b-col cols="8" lg="10">
                     <div class="guest-title">{{ $t("3-12_Guest_Name") }}</div>
                     <div class="guest-info">
                      <ul>
                        <li>{{ $t("3-12_Guest_Info-1") }}</li>
                      </ul>                    
                    </div>
                    <div class="guest-content">
                      <h5>{{ $t("Guest_Intro") }}</h5>
                      <p>{{ $t("3-12_Guest_Intro-1") }}</p>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col>
              <div class="guest-wrap">
                <b-row>
                  <b-col cols="4" lg="2">                    
                    <div class="guest-pic">
                      <b-img
                        :src="require('@/assets/imgs/guest/CHANG_TAI.png')"
                        fluid
                        alt="CHANG,TAI"
                      ></b-img>
                    </div>
                  </b-col>
                  <b-col cols="8" lg="10">
                     <div class="guest-title">{{ $t("3-13_Guest_Name") }}</div>
                     <div class="guest-info">
                      <ul>
                        <li>{{ $t("3-13_Guest_Info-1") }}</li>
                      </ul>                    
                    </div>
                    <div class="guest-content">
                      <h5>{{ $t("Guest_Intro") }}</h5>
                      <p>{{ $t("3-13_Guest_Intro-1") }}</p>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col>
              <div class="guest-wrap">
                <b-row>
                  <b-col cols="4" lg="2">                    
                    <div class="guest-pic">
                      <b-img
                        :src="require('@/assets/imgs/guest/PSWu.png')"
                        fluid
                        alt="PS Wu"
                      ></b-img>
                    </div>
                  </b-col>
                  <b-col cols="8" lg="10">
                     <div class="guest-title">{{ $t("3-1_Guest_Name") }}</div>
                     <div class="guest-info">
                      <ul>
                        <li>{{ $t("3-1_Guest_Info-1") }}</li>
                        <li>{{ $t("3-1_Guest_Info-2") }}</li>
                      </ul>                    
                    </div>
                    <div class="guest-content">
                      <h5>{{ $t("Guest_Intro") }}</h5>
                      <p>{{ $t("3-1_Guest_Intro-1") }}</p>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col>
              <div class="guest-wrap">
                <b-row>
                  <b-col cols="4" lg="2">                    
                    <div class="guest-pic">
                      <b-img
                        :src="require('@/assets/imgs/guest/Ya_Ning_Yen.png')"
                        fluid
                        alt="Ya-Ning Yen"
                      ></b-img>
                    </div>
                  </b-col>
                  <b-col cols="8" lg="10">
                     <div class="guest-title">{{ $t("3-2_Guest_Name") }}</div>
                     <div class="guest-info">
                      <ul>
                        <li>{{ $t("3-2_Guest_Info-1") }}</li>
                      </ul>                    
                    </div>
                    <div class="guest-content">
                      <h5>{{ $t("Guest_Intro") }}</h5>
                      <p>{{ $t("3-2_Guest_Intro-1") }}</p>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col>
              <div class="guest-wrap">
                <b-row>
                  <b-col cols="4" lg="2">                    
                    <div class="guest-pic">
                      <b-img
                        :src="require('@/assets/imgs/guest/kuangchi.png')"
                        fluid
                        alt="kuangchi"
                      ></b-img>
                    </div>
                  </b-col>
                  <b-col cols="8" lg="10">
                     <div class="guest-title">{{ $t("3-3_Guest_Name") }}</div>
                     <div class="guest-info">
                      <ul>
                        <li>{{ $t("3-3_Guest_Info-1") }}</li>
                      </ul>                    
                    </div>
                    <div class="guest-content">
                      <h5>{{ $t("Guest_Intro") }}</h5>
                      <p>{{ $t("3-3_Guest_Intro-1") }}</p>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col>
              <div class="guest-wrap">
                <b-row>
                  <b-col cols="4" lg="2">                    
                    <div class="guest-pic">
                      <b-img
                        :src="require('@/assets/imgs/guest/CHANG_CHING-YEH.png')"
                        fluid
                        alt="CHANG CHING-YEH"
                      ></b-img>
                    </div>
                  </b-col>
                  <b-col cols="8" lg="10">
                     <div class="guest-title">{{ $t("3-4_Guest_Name") }}</div>
                     <div class="guest-info">
                      <ul>
                        <li>{{ $t("3-4_Guest_Info-1") }}</li>
                      </ul>                    
                    </div>
                    <div class="guest-content">
                      <h5>{{ $t("Guest_Intro") }}</h5>
                      <p>{{ $t("3-4_Guest_Intro-1") }}</p>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col>
              <div class="guest-wrap">
                <b-row>
                  <b-col cols="4" lg="2">                    
                    <div class="guest-pic">
                      <b-img
                        :src="require('@/assets/imgs/guest/CHEN_PEI-LING.png')"
                        fluid
                        alt="CHEN PEI-LING"
                      ></b-img>
                    </div>
                  </b-col>
                  <b-col cols="8" lg="10">
                     <div class="guest-title">{{ $t("3-5_Guest_Name") }}</div>
                     <div class="guest-info">
                      <ul>
                        <li>{{ $t("3-5_Guest_Info-1") }}</li>
                      </ul>                    
                    </div>
                    <div class="guest-content">
                      <h5>{{ $t("Guest_Intro") }}</h5>
                      <p>{{ $t("3-5_Guest_Intro-1") }}</p>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col>
              <div class="guest-wrap">
                <b-row>
                  <b-col cols="4" lg="2">                    
                    <div class="guest-pic">
                      <b-img
                        :src="require('@/assets/imgs/guest/HUANG_HSIN-CHUAN.jpg')"
                        fluid
                        alt="HUANG HSIN-CHUAN"
                      ></b-img>
                    </div>
                  </b-col>
                  <b-col cols="8" lg="10">
                     <div class="guest-title">{{ $t("3-6_Guest_Name") }}</div>
                     <div class="guest-info">
                      <ul>
                        <li>{{ $t("3-6_Guest_Info-1") }}</li>
                      </ul>                    
                    </div>
                    <div class="guest-content">
                      <h5>{{ $t("Guest_Intro") }}</h5>
                      <p>{{ $t("3-6_Guest_Intro-1") }}</p>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col>
              <div class="guest-wrap">
                <b-row>
                  <b-col cols="4" lg="2">                    
                    <div class="guest-pic">
                      <b-img
                        :src="require('@/assets/imgs/guest/Huang_Kuo-chao.png')"
                        fluid
                        alt="Huang Kuo-chao"
                      ></b-img>
                    </div>
                  </b-col>
                  <b-col cols="8" lg="10">
                     <div class="guest-title">{{ $t("3-7_Guest_Name") }}</div>
                     <div class="guest-info">
                      <ul>
                        <li>{{ $t("3-7_Guest_Info-1") }}</li>
                      </ul>                    
                    </div>
                    <div class="guest-content">
                      <h5>{{ $t("Guest_Intro") }}</h5>
                      <p>{{ $t("3-7_Guest_Intro-1") }}</p>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col>
              <div class="guest-wrap">
                <b-row>
                  <b-col cols="4" lg="2">                    
                    <div class="guest-pic">
                      <b-img
                        :src="require('@/assets/imgs/guest/Sin-Heng_Wang.jpg')"
                        fluid
                        alt="Sin-Heng Wang"
                      ></b-img>
                    </div>
                  </b-col>
                  <b-col cols="8" lg="10">
                     <div class="guest-title">{{ $t("3-8_Guest_Name") }}</div>
                     <div class="guest-info">
                      <ul>
                        <li>{{ $t("3-8_Guest_Info-1") }}</li>
                      </ul>                    
                    </div>
                    <div class="guest-content">
                      <h5>{{ $t("Guest_Intro") }}</h5>
                      <p>{{ $t("3-8_Guest_Intro-1") }}</p>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col>
              <div class="guest-wrap">
                <b-row>
                  <b-col cols="4" lg="2">                    
                    <div class="guest-pic">
                      <b-img
                        :src="require('@/assets/imgs/guest/Hsiao_Wei_Lin.jpg')"
                        fluid
                        alt="Hsiao Wei Lin"
                      ></b-img>
                    </div>
                  </b-col>
                  <b-col cols="8" lg="10">
                     <div class="guest-title">{{ $t("3-9_Guest_Name") }}</div>
                     <div class="guest-info">
                      <ul>
                        <li>{{ $t("3-9_Guest_Info-1") }}</li>
                      </ul>                    
                    </div>
                    <div class="guest-content">
                      <h5>{{ $t("Guest_Intro") }}</h5>
                      <p>{{ $t("3-9_Guest_Intro-1") }}</p>
                      <ul>
                        <li>{{ $t("3-9_Guest_Intro-2") }}</li>
                        <li>{{ $t("3-9_Guest_Intro-3") }}</li>
                        <li>{{ $t("3-9_Guest_Intro-4") }}</li>
                      </ul>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col>
              <div class="guest-wrap">
                <b-row>
                  <b-col cols="4" lg="2">                    
                    <div class="guest-pic">
                      <b-img
                        :src="require('@/assets/imgs/guest/WANG_CHAO-PAO.jpg')"
                        fluid
                        alt="WANG CHAO-PAO"
                      ></b-img>
                    </div>
                  </b-col>
                  <b-col cols="8" lg="10">
                     <div class="guest-title">{{ $t("3-10_Guest_Name") }}</div>
                     <div class="guest-info">
                      <ul>
                        <li>{{ $t("3-10_Guest_Info-1") }}</li>
                      </ul>                    
                    </div>
                    <div class="guest-content">
                      <h5>{{ $t("Guest_Intro") }}</h5>
                      <p>{{ $t("3-10_Guest_Intro-1") }}</p>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col>
              <div class="guest-wrap">
                <b-row>
                  <b-col cols="4" lg="2">                    
                    <div class="guest-pic">
                      <b-img
                        :src="require('@/assets/imgs/guest/HSIEH_MING-HSUN.jpg')"
                        fluid
                        alt="HSIEH MING-HSUN"
                      ></b-img>
                    </div>
                  </b-col>
                  <b-col cols="8" lg="10">
                     <div class="guest-title">{{ $t("3-11_Guest_Name") }}</div>
                     <div class="guest-info">
                      <ul>
                        <li>{{ $t("3-11_Guest_Info-1") }}</li>
                      </ul>                    
                    </div>
                    <div class="guest-content">
                      <h5>{{ $t("Guest_Intro") }}</h5>
                      <p>{{ $t("3-11_Guest_Intro-1") }}</p>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>

      </b-container>


    </div>    
    
    <ul id="myMenu">
      <li>
        <b-link to="/" tooltip="首頁" flow="left"
          ><span class="icon-home2" :title="$t('rightNav01')"></span
          ><span class="sr-only">{{ $t("TopNav01") }}</span>
        </b-link>
      </li>
      <!-- <li>
        <a
          href="https://forms.gle/am2QVZTjfZRq7pBF8"
          target="_blank"
          tooltip="報名論壇"
          flow="left"
          :title="$t('rightNav02-1')"
          ><span class="icon-add-user"></span>
          <span class="sr-only">{{ $t("TopNav05") }}</span></a
        >
      </li> -->
      <li>
        <a
          href="javascript:"
          v-scroll-to="'#top'"
          :title="$t('rightNav07')"
          ><span class="icon-arrow_up"></span><span class="sr-only">top</span></a
        >
      </li>
    </ul>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        navigationActive: [],
        items: [
          {
            text: this.$t("TopNav01") ,
            href: "#/",
          },
          {
            text: this.$t("TopNav03") ,
            active: true,
          },
        ],
      };
    },
    mounted() {
      window.scrollTo(0, 0);
      window.addEventListener("scroll", this.updateScroll);
    },
    methods: {
      updateScroll() {
        this.navigationActive = [false, false, false, false];
        let scroll = Math.round(window.scrollY);
        if (scroll < this.pageHeight2) {
          this.navigationActive[0] = true;
        } else if (scroll >= this.pageHeight2 && scroll < this.pageHeight3) {
          this.navigationActive[1] = true;
        } else if (scroll >= this.pageHeight3 && scroll < this.pageHeight4) {
          this.navigationActive[2] = true;
        } else if (scroll >= this.pageHeight4) {
          this.navigationActive[3] = true;
        }
        this.nowScroll = scroll;
      },
    },
  };
</script>
<style lang="scss"></style>
